import { useTranslation } from 'react-i18next';
import { type BankModuleSpecsFragment } from '../../../../../api/fragments/BankModuleSpecs';
import {
    CreateBankModuleDocument,
    type CreateBankModuleMutation,
    type CreateBankModuleMutationVariables,
} from '../../../../../api/mutations/createBankModule';
import { type BankModuleSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import BankModulePage, { type BankModulePageProps } from '../../BankModulePage';
import { type ModuleImplementation } from './types';

const implementation: ModuleImplementation<BankModuleSpecsFragment, BankModuleSettings> = {
    PageComponent: ({ module }: BankModulePageProps) => <BankModulePage module={module} />,
    getTitle: t => t('moduleDetails:implementations.BankModule.className'),
    FormComponent: () => {
        const { t } = useTranslation(['moduleDetails']);

        return (
            <InputField
                {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                name="displayName"
                required
            />
        );
    },
    getValidator: () => validators.compose(validators.requiredNonEmptyString('displayName')),
    create: async (apolloClient, companyId, values) =>
        apolloClient
            .mutate<CreateBankModuleMutation, CreateBankModuleMutationVariables>({
                mutation: CreateBankModuleDocument,
                variables: { companyId, settings: values },
            })
            .then(({ data }) => data.module),
};

export default implementation;
